import React, { Fragment, useMemo } from 'react';
import { XR } from '..';
import { XIcon, XRouterLink, XLoader } from '../../ui';
import times from 'lodash/times';
import { preventClick } from '../../util/preventClick';
import { useImmer } from 'use-immer';
export function useList(input) {
    var title = input.title, items = input.items;
    var itemCount = items.length;
    var keys = useMemo(function () { return times(itemCount).map(function () { return Math.random(); }); }, [itemCount]);
    return {
        element: (React.createElement(XR.Section, { className: 'XR-useList' },
            title && React.createElement("div", { className: 'title' }, title),
            React.createElement(XR.Card, { className: 'items-container' }, items.map(function (item, index) {
                var to = item.to;
                var key = keys[index];
                if (to) {
                    return (React.createElement(XRouterLink, { to: to, key: key },
                        React.createElement(Item, { item: item })));
                }
                return (React.createElement(Fragment, { key: key },
                    React.createElement(Item, { item: item })));
            })))),
    };
}
function Item(_a) {
    var item = _a.item;
    var type = item.type, title = item.title, subtitle = item.subtitle, value = item.value, iconLeft = item.iconLeft, iconRight = item.iconRight, content = item.content, onClick = item.onClick, isLoading = item.isLoading;
    var to = item.to;
    var toggleValue = item.value;
    var _b = useImmer({
        isToggleActive: toggleValue,
    }), state = _b[0], setState = _b[1];
    return (React.createElement(Fragment, null,
        React.createElement(XR.Touchable, { variant: 'text', onClick: function () {
                onClick === null || onClick === void 0 ? void 0 : onClick();
                if (type === 'toggle') {
                    var isActive_1 = !state.isToggleActive;
                    setState(function (state) {
                        state.isToggleActive = isActive_1;
                    });
                    item.onChangeValue(isActive_1);
                }
            }, className: 'item-container' },
            isLoading && (React.createElement("div", { className: 'loader', onClick: function (event) {
                    event.stopPropagation();
                } },
                React.createElement(XLoader, null))),
            React.createElement("div", { className: 'left' },
                iconLeft && React.createElement(XIcon, null, iconLeft),
                React.createElement("div", null,
                    title && React.createElement("div", { className: 'title' }, title),
                    subtitle && React.createElement("div", { className: 'subtitle' }, subtitle))),
            React.createElement("div", { className: 'right' }, (type === 'toggle' && (React.createElement("div", { className: "switch-container" },
                React.createElement("div", { className: "switch" },
                    React.createElement("input", { type: "checkbox", checked: toggleValue !== null && toggleValue !== void 0 ? toggleValue : state.isToggleActive, onClick: preventClick, onChange: function () { } }),
                    React.createElement("span", { className: "slider" }))))) ||
                (to && React.createElement(XIcon, null, "keyboard_arrow_right")) ||
                value ||
                (iconRight && React.createElement(XIcon, null, iconRight)))),
        content));
}
